import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = 'Confirm Action',
    message = 'Do you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    isLoading = false
}) => {
    if (!isOpen) return null;

    return (
        <div className="confirmation-overlay">
            <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
                {/* <div className="confirmation-header">
                    <h2>{title}</h2>
                </div> */}

                <div className="confirmation-body">
                    <p className="confirmation-message">{message}</p>
                </div>

                <div className="confirmation-footer">
                    <button
                        type="button"
                        className="confirmation-btn confirmation-btn-confirm"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {confirmText}
                    </button>
                    <button
                        type="button"
                        className="confirmation-btn confirmation-btn-cancel"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        {cancelText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;